import { render, staticRenderFns } from "./recoredEdit.vue?vue&type=template&id=8556f3a0&scoped=true"
import script from "./recoredEdit.vue?vue&type=script&lang=js"
export * from "./recoredEdit.vue?vue&type=script&lang=js"
import style0 from "./recoredEdit.vue?vue&type=style&index=0&id=8556f3a0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8556f3a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8556f3a0')) {
      api.createRecord('8556f3a0', component.options)
    } else {
      api.reload('8556f3a0', component.options)
    }
    module.hot.accept("./recoredEdit.vue?vue&type=template&id=8556f3a0&scoped=true", function () {
      api.rerender('8556f3a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wareHouse/recoredEdit.vue"
export default component.exports